var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState, useEffect, useCallback, } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "@/api/ApiClient";
import { useCart } from "@/context/CartContext";
import { mergeAnonymousCartWithCustomerCart } from "@/api/cart/cartMergeUtils";
const AuthContext = createContext(undefined);
export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const [customer, setCustomer] = useState(null);
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { cart, reloadCart, clearCart, removeAllDiscountCodes, resetCartService, } = useCart();
    useEffect(() => {
        const initializeAuth = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                apiClient.initClientFromStorage();
                const raw = localStorage.getItem("accessToken");
                const storedToken = raw ? JSON.parse(raw) : null;
                const isValid = (storedToken === null || storedToken === void 0 ? void 0 : storedToken.expirationTime) &&
                    storedToken.expirationTime > Date.now();
                if (!isValid) {
                    localStorage.removeItem("accessToken");
                    return;
                }
                const customer = yield apiClient.getCustomerProfile();
                setCustomer(customer);
                setToken(storedToken.token);
            }
            catch (error) {
                console.warn("Auth restoration failed:", error);
                localStorage.removeItem("accessToken");
            }
            finally {
                setLoading(false);
            }
        });
        initializeAuth();
    }, []);
    const clearError = useCallback(() => setError(null), []);
    // const login = useCallback(
    //   async (
    //     email: string,
    //     password: string,
    //     options?: { preventRedirect?: boolean },
    //   ): Promise<Customer> => {
    //     setLoading(true);
    //     clearError();
    //     localStorage.removeItem("accessToken");
    //     try {
    //       const customerSignIn = await apiClient.getCustomerWithPassword(email, password);
    //       setCustomer(customerSignIn);
    //       const stored = localStorage.getItem("accessToken");
    //       if (stored) {
    //         const parsed: TokenStore = JSON.parse(stored);
    //         setToken(parsed.token);
    //       }
    //       const mergedCart = await mergeAnonymousCartWithCustomerCart();
    //       if (mergedCart) {
    //         localStorage.setItem("customerCartId", mergedCart.id);
    //       }
    //       resetCartService();
    //       await reloadCart();
    //       if (!options?.preventRedirect) {
    //         navigate("/");
    //       }
    //       return customerSignIn;
    //     } catch (err) {
    //       const msg = err instanceof Error ? err.message : "Login failed";
    //       setError(msg);
    //       throw new Error(msg);
    //     } finally {
    //       setLoading(false);
    //     }
    //   },
    //   [clearError, navigate, reloadCart],
    // );
    const login = useCallback((email, password, options) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        clearError();
        localStorage.removeItem("accessToken");
        try {
            // 🔐 Логин по email/password
            const customerSignIn = yield apiClient.getCustomerWithPassword(email, password);
            setCustomer(customerSignIn);
            const stored = localStorage.getItem("accessToken");
            if (stored) {
                const parsed = JSON.parse(stored);
                setToken(parsed.token);
            }
            // merge anonymous cart with customer cart
            yield mergeAnonymousCartWithCustomerCart();
            // 🧼   Clean temporary localstorage
            localStorage.removeItem("anonymousCartId");
            localStorage.removeItem("anonymousId");
            // reset cart service
            // (this will create a new cart for the customer)
            resetCartService();
            // 🔄 Reload the cart
            yield reloadCart();
            if (!(options === null || options === void 0 ? void 0 : options.preventRedirect)) {
                navigate("/");
            }
            return customerSignIn;
        }
        catch (err) {
            const msg = err instanceof Error ? err.message : "Login failed";
            setError(msg);
            throw new Error(msg);
        }
        finally {
            setLoading(false);
        }
    }), [clearError, navigate, reloadCart]);
    const loginWithToken = useCallback((token) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        clearError();
        try {
            const customerSignIn = yield apiClient.getCustomerWithToken(token);
            if (customerSignIn) {
                const profile = yield apiClient.getCustomerProfile();
                setCustomer(profile);
                setToken(token);
            }
            else {
                localStorage.removeItem("accessToken");
            }
        }
        catch (err) {
            const msg = err instanceof Error ? err.message : "Session validation failed";
            setError(msg);
            throw new Error(msg);
        }
        finally {
            setLoading(false);
        }
    }), [clearError]);
    // const logout = useCallback(async () => {
    //   const token = localStorage.getItem("accessToken");
    //   try {
    //     if (token && cart && cart.discountCodes.length > 0) {
    //       await removeAllDiscountCodes(); // ✅ Один раз — удаляет все скидки
    //     }
    //   } catch (err) {
    //     console.warn("Failed to remove discount codes during logout", err);
    //   }
    //   localStorage.removeItem("accessToken");
    //   localStorage.removeItem("customerCartId");
    //   setCustomer(null);
    //   setToken(null);
    //   apiClient.initAnonymousClient();
    //   clearCart();
    //   await removeAllDiscountCodes();
    //   await clearCart(); // <--- создаёт полностью новую корзину
    //   await reloadCart(); // <--- перезагружает корзину после очистки
    // }, [cart, clearCart, reloadCart, removeAllDiscountCodes]);
    const logout = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const token = localStorage.getItem("accessToken");
        yield apiClient.logout();
        localStorage.removeItem("accessToken");
        localStorage.removeItem("customerCartId");
        setCustomer(null);
        setToken(null);
        //  Clean cart and create a new one
        yield clearCart();
        yield reloadCart();
        // Set anonymous cart ID in localStorage
        if (cart && cart.id) {
            localStorage.setItem("anonymousCartId", cart.id);
        }
    }), [cart, clearCart, reloadCart, removeAllDiscountCodes]);
    const register = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        clearError();
        localStorage.removeItem("accessToken");
        try {
            yield apiClient.registerCustomer(data);
            const profile = yield apiClient.getCustomerProfile();
            setCustomer(profile);
            const stored = localStorage.getItem("accessToken");
            if (stored) {
                const parsed = JSON.parse(stored);
                setToken(parsed.token);
            }
            return profile;
        }
        catch (err) {
            let msg = "Registration failed";
            if (err instanceof Error) {
                msg = err.message.includes("DuplicateField")
                    ? "Email already exists"
                    : err.message;
            }
            setError(msg);
            throw new Error(msg);
        }
        finally {
            setLoading(false);
        }
    }), [clearError]);
    const refreshToken = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!token)
            return;
        setLoading(true);
        try {
            yield loginWithToken(token);
        }
        catch (err) {
            console.error("Token refresh failed:", err);
            yield logout();
        }
        finally {
            setLoading(false);
        }
    }), [token, loginWithToken, logout]);
    const relogin = useCallback((_a) => __awaiter(void 0, [_a], void 0, function* ({ email, password }) {
        try {
            yield login(email, password, { preventRedirect: true });
        }
        catch (err) {
            console.error("Relogin failed", err);
        }
    }), [login]);
    const value = {
        isAuth: !!customer,
        customer,
        token,
        login,
        loginWithToken,
        logout,
        relogin,
        register,
        loading,
        error,
        clearError,
        refreshToken,
        setCustomer,
    };
    return _jsx(AuthContext.Provider, { value: value, children: children });
};
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
